var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcInfoOutline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.0833333,15.5833333 L11.9166667,15.5833333 L11.9166667,10.0833333 L10.0833333,10.0833333 L10.0833333,15.5833333 L10.0833333,15.5833333 Z M11,1.83333333 C5.94,1.83333333 1.83333333,5.94 1.83333333,11 C1.83333333,16.06 5.94,20.1666667 11,20.1666667 C16.06,20.1666667 20.1666667,16.06 20.1666667,11 C20.1666667,5.94 16.06,1.83333333 11,1.83333333 L11,1.83333333 Z M11,18.3333333 C6.9575,18.3333333 3.66666667,15.0425 3.66666667,11 C3.66666667,6.9575 6.9575,3.66666667 11,3.66666667 C15.0425,3.66666667 18.3333333,6.9575 18.3333333,11 C18.3333333,15.0425 15.0425,18.3333333 11,18.3333333 L11,18.3333333 Z M10.0833333,8.25 L11.9166667,8.25 L11.9166667,6.41666667 L10.0833333,6.41666667 L10.0833333,8.25 L10.0833333,8.25 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1.-Save-leads-modal",
    transform: "translate(-680.000000, -341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(480.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(20.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select/Large/Placeholder",
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right",
    transform: "translate(179.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black",
    fill: "#BEC4CA",
    xlinkHref: "#path-3"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcInfoOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-info-outline.c7a76ba9.svg";
export { ForwardRef as ReactComponent };